import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { WorkerService } from 'app/_services/worker.service';
import { NotificationService } from 'app/_services/notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'send-email',
  templateUrl: './send-email.component.html',
})
export class SendEmailComponent implements OnInit {
  public sendMailForm: FormGroup;
  public workerUserCount: number;
  public siteOwnerCount: number;
  public contractorManagerCount: number;
  public siteDelegateCount: number;
  public hideDelegateCheckBox: boolean = false;
  public selectedAttachments: any[] = [];

  public sendInProgress = false;


  constructor(
    private notificationService: NotificationService,
    private workerService: WorkerService,
    fb: FormBuilder,
  ) {
    this.sendMailForm = fb.group({
      subject: new FormControl('', [Validators.required]),
      content: new FormControl('', [Validators.required]),
      test: new FormControl(true, [Validators.required]),
      workerUserGroup: new FormControl(false, [Validators.required]),
      maintenanceManagerGroup: new FormControl(false, [Validators.required]),
      siteOwnerGroup: new FormControl(false, [Validators.required]),
      siteDelegateGroup: new FormControl(false, [Validators.required]),
    }, {
      validator: (formControl) => {
        if (!formControl.controls.workerUserGroup.value
          && !formControl.controls.maintenanceManagerGroup.value
          && !formControl.controls.siteDelegateGroup.value
          && !formControl.controls.siteOwnerGroup.value) {
            return {invalid: true};
        }
      }
    });
  }

  ngOnInit() {
    this.countUsers("workerUser");
    this.countUsers("maintenanceManager");
    this.countUsers("siteOwner");
    this.countUsers("siteDelegate");
  }

  public countUsers(userType :string) {
    this.workerService.getUserCount(userType).subscribe((response) => {
      const result: number  = Number(response.body);
      if(userType === 'workerUser') {
        this.workerUserCount = result;
      } else if(userType === 'siteOwner') {
        this.siteOwnerCount = result;
      } else if(userType === 'maintenanceManager') {
        this.contractorManagerCount = result;
      } else if(userType === 'siteDelegate') {
        this.siteDelegateCount = result;
      }
    });
  }

  public onSubmit() {
    this.sendInProgress = true;
    const isTest = this.sendMailForm.value.test;
    const body = {
      subject: this.sendMailForm.value.subject,
      content: this.sendMailForm.value.content,
      test: isTest,
      workerUserGroup: this.sendMailForm.value.workerUserGroup,
      maintenanceManagerGroup: this.sendMailForm.value.maintenanceManagerGroup,
      siteOwnerGroup: this.sendMailForm.value.siteOwnerGroup,
      siteDelegateGroup: this.sendMailForm.value.siteDelegateGroup,
    };
    if (!isTest) {
      let totalReclipients = 0;
      if (body.workerUserGroup) {
        totalReclipients += this.workerUserCount;
      }
      if (body.maintenanceManagerGroup) {
        totalReclipients += this.contractorManagerCount;
      }
      if (body.siteOwnerGroup) {
        totalReclipients += this.siteOwnerCount;
      }
      if (body.siteDelegateGroup) {
        totalReclipients += this.siteDelegateCount;
      }
      Swal.fire({
        title: 'Send Mail?',
        text: `This will send a mail to ${totalReclipients} recipients. Are you sure? `,
        type: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'confirm-danger',
        },
        confirmButtonText: 'Send Mail!',
      }).then((result) => {
        if (result.value) {
          this.sendMail(body);
        } else {
          this.sendInProgress = false;
        }
      });
    } else {
      this.sendMail(body);
    }
  }

  private sendMail(body) {
    this.workerService.sendMail(body, this.selectedAttachments).subscribe((response: any) => {
      if (body.test) {
        this.notificationService.notify('success', `Email sent to admin only`);
      } else {
        this.notificationService.notify('success', `Email sent to ${response.recipientCount} users`);
      }
      this.sendInProgress = false;
    }, error => {
      console.error(error);
      this.sendInProgress = false;
      this.notificationService.notify('danger', `Error sending email: ${error}`);
      throw error;
    })
  }
  public onWorkerUserGroupChange(event) {
    if(event){
      this.sendMailForm.patchValue({siteDelegateGroup: false});
      this.hideDelegateCheckBox = true;
    } else {
      this.hideDelegateCheckBox = false;
    }
  }
  public onFileChange(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      this.selectedAttachments.push(file);
    }
  }

}
